const organizationType = {
    AGENCY : 1,

    CARRIER : 2,

    MGA_CARRIER : 3,

    MGA_AGENCY : 4,

    AGENCY_STRING : 'agency',

    CARRIER_STRING : 'carrier',

    MGA_CARRIER_STRING : 'mgaCarrier',

    MGA_AGENCY_STRING : 'mgaAgency'

};

angular.module('gw-um-j2js')
    .constant('organizationType', organizationType);